import {
  CLEAR_INSURANCES,
  CLEAR_INSURANCE_OPTIONS,
  CLEAR_EQUIPMENT_OPTIONS,
  LOAD_INSURANCES,
  SAVE_INSURANCE_OPTIONS,
  LOAD_INSURANCE_DETAIL,
  CLEAR_INSURANCE_DETAIL,
  LOAD_INSURANCE_EQUIPMENTS,
  CLEAR_INSURANCE_EQUIPMENTS,
  SAVE_EQUIPMENT_OPTIONS
} from '../actions/insuranceActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
    // sort: { property: 'remainingDays', order: 'asc' },
  },
  equipmentOptions: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0,
  detail: null,
  equipments: [],
  equipmentCount: 0,
  equipment: { items: [], count: 0 }
};

const insuranceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_INSURANCE_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...(action.options || {}) }
      };
    }
    case SAVE_EQUIPMENT_OPTIONS: {
      return {
        ...state,
        equipmentOptions: {
          ...state.equipmentOptions,
          ...(action.options || {})
        }
      };
    }
    case CLEAR_INSURANCE_OPTIONS: {
      return {
        options: initialState.options,
        items: state.items,
        count: state.count
      };
    }
    case CLEAR_EQUIPMENT_OPTIONS: {
      return {
        ...state,
        equipmentOptions: initialState.equipmentOptions
      };
    }
    case LOAD_INSURANCES.success: {
      return {
        options: state.options,
        items: action.items,
        count: action.count
      };
    }
    case CLEAR_INSURANCES: {
      return initialState;
    }
    case CLEAR_INSURANCE_EQUIPMENTS: {
      return {
        ...state,
        equipments: []
      };
    }
    case LOAD_INSURANCE_DETAIL.success: {
      return {
        ...state,
        detail: action.data
      };
    }

    case CLEAR_INSURANCE_DETAIL: {
      return {
        ...state,
        detail: null
      };
    }
    case LOAD_INSURANCE_EQUIPMENTS.success: {
      const equipmentData = {
        items: action.data.items,
        count: action.data.count
      };
      const newState = {
        ...state,
        equipments: equipmentData.items,
        equipmentCount: equipmentData.count
      };

      return newState;
    }
    default: {
      return state;
    }
  }
};

export default insuranceReducer;
